<template>
  <div class="row">
    <div class="col-md-12 text-right">
      <app-spinner v-if="isLoading"/>
      <template v-else-if="!refunded">
        <div class="row">
          <div class="col-md-6">
            <refund-transactions :transactions="refundPayment && refundPayment.transactions"/>
          </div>
          <div class="col-md-6">
            <!--
            <el-button v-if="!isD365APStatus" type="primary" :loading="!isProcessed">
              <template v-if="!isProcessed">D365 Processing</template>
              <template v-else>D365 Processed:</template>
              {{isProcessed}}
            </el-button>
            -->
            <el-button
                @click.native="refund"
                type="success"
                round>Process Refund
              <strong>{{refundAmount | currency}}</strong>
            </el-button>
          </div>
        </div>
      </template>
      <template v-else-if="refunded">
        <order-refund-transactions :refund="refunded"/>
      </template>
    </div>
    <div v-if="isD365APStatus" class="col-md-12">
      <h4 class="alert alert-warning m-a-1" role="alert">
        <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
        {{d365OrderNotUpdated}}
      </h4>
      <order-difference v-if="order && draftOrder"
                        :originalOrder="order"
                        :updatedOrder="draftOrder"
                        :d365Order="d365Order"
                        :discountPercent="discountPercent"/>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
  import {currency} from '../../../filters';
import {
  ORDER_GET_DISCOUNT_PERCENT,
  ORDER_REFUND_PAYMENT, ORDER_SET_HIDE_BUTTON, ORDER_SET_LOADING,
} from '../../../store/types';
  import {
    D365_ORDER_NOT_UPDATED,
  } from '../../../lang/en/notify';
  import {
    LOGON_STATUS_PT,
  } from '../../../lang/en/constants';
  import {RepositoryFactory} from '../../../repositories/RepositoryFactory';
  import AppSpinner from '../../ui/AppSpinner';
  import OrderDifference from '../Shared/OrderDifference';
  import RefundTransactions from '../Shared/RefundTransactions';
  import OrderRefundTransactions from '../Shared/OrderRefundTransactions';
  import {notify} from "../../../utils";

  const OCAEditHistoryRepository = RepositoryFactory.get(
      'acadia/oca/edit-history');

  export default {
    name: 'OrderUpdateSuccessPage',
    filters: {
      currency,
    },
    components: {
      AppSpinner,
      OrderDifference,
      RefundTransactions,
      OrderRefundTransactions,
    },
    computed: {
      ...mapState({
        isLoading: state => state.order.loading,
        refundPayment: state => state.order.payment.refund,
        order: state => state.order.order,
        d365Order: state => state.order.d365Order,
        draftOrder: state => state.order.draftOrder,
        isD365APStatus: state => {
          if (!state.order.d365Order) {
            return false;
          }

          const {state: d365OrderState} = state.order.d365Order;

          return LOGON_STATUS_PT.indexOf(d365OrderState) !== -1;
        },
        history: state => state.order.history,
      }),
      ...mapGetters({
        discountPercent: ORDER_GET_DISCOUNT_PERCENT,
      }),
      refundAmount() {
        if(!this.refundPayment) {
          return 0;
        }

        const reducer = (amount, transaction) => {
          return amount + Number(transaction.amount);
        };
        return this.refundPayment.transactions.reduce(reducer, 0);
      },
    },
    methods: {
      ...mapActions({
        refundShopify: ORDER_REFUND_PAYMENT,
      }),
      ...mapMutations({
        hideButton: ORDER_SET_HIDE_BUTTON
      }),
      refund: function(event) {
        event.currentTarget.disabled = true;

        this.refundShopify().then(response => {
          return response.data.refund;
        }).then(refund => {
          this.refunded = refund.refund || refund;
          this.hideButton(false);
          this.refundClicked=true;
        });
      },
      preventNav(event) {
        if(_.isNull(this.order.id)) {
          this.$router.push({path: 'update'});
          return;
        }
        if (this.refundClicked){
          return;
        }
        const warningMsg = "Please click refund before you leave the page!";
        notify(warningMsg, 'danger');
        event.preventDefault()
        event.returnValue = warningMsg;
        return warningMsg;
      },
    },
    data() {
      return {
        isProcessed: null,
        refunded: null,
        refundClicked:false,
        d365OrderNotUpdated: D365_ORDER_NOT_UPDATED,
        loading:false
      };
    },
    created() {
      this.hideButton(true);
      if(_.isNull(this.order.id)) {
        this.$router.push({path: 'update'});
        return;
      }

      const id = this.history.id;
      const d365Check = setInterval(() => {
        OCAEditHistoryRepository.show(id).then(response => {
          this.isProcessed = response.data.processed_at;

          if (this.isProcessed !== null) {
            clearInterval(d365Check);
          }
        }).catch(error => {
          clearInterval(d365Check);
          throw error;
        });
      }, 2000);
    },
    mounted() {
      window.scrollTo(0, 0);
    },
    beforeMount() {
      //if there's 0 to refund
      if (this.refundAmount===0){
        this.refundClicked = true;
      }
      window.addEventListener("beforeunload", this.preventNav)
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("beforeunload", this.preventNav);
      })
    },
    beforeRouteLeave(to, from, next) {
      if (!this.refundClicked && !_.isNull(this.order.id)){
        const warningMsg = "Please click refund before you leave the page!";
        notify(warningMsg, 'danger');
      }else{
        this.hideButton(false);
        next();
      }
    },
  };
</script>
